module.exports = {
      id: "vikatan-play-logo-red-usage",
      viewBox: "0 0 536.066 789.439",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatan-play-logo-red",
      toString: function () {
        return this.url;
      }
    }